import { render, staticRenderFns } from "./setUploadPhoto.vue?vue&type=template&id=0cecd394&scoped=true"
import script from "./setUploadPhoto.vue?vue&type=script&lang=js"
export * from "./setUploadPhoto.vue?vue&type=script&lang=js"
import style0 from "./setUploadPhoto.vue?vue&type=style&index=0&id=0cecd394&prod&lang=less&scoped=true"
import style1 from "./setUploadPhoto.vue?vue&type=style&index=1&id=0cecd394&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cecd394",
  null
  
)

export default component.exports